export const maxWidthContent = '1536px';